import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {Close,LastPage,AllInclusive,Add,MoreVert,Edit,Delete,Done,Block,Visibility,Gavel,FilterList, FormatListNumbered,ConfirmationNumber,HourglassEmpty,Check,GraphicEq} from '@material-ui/icons';

import { withLocalize,Translate } from "react-localize-redux";

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  CircularProgress,
  FormHelperText,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Grid,
  Link,
  Slide,
  Popover
} from "@material-ui/core";

import Format from "date-fns/format";

import { MuiPickersUtilsProvider, DatePicker,KeyboardTimePicker } from "@material-ui/pickers";

import {useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { useSnackbar } from 'notistack';

import {TransportService,ReportingService,AdminService,FinanceService,groupBy} from "./../../utils/web_config_2";


import UserInfo from "./login_info";

import DateFnsUtils from "@date-io/date-fns";

import axios from 'axios';

import Chart from 'react-apexcharts'

import Skeleton from '@material-ui/lab/Skeleton';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { format } from "date-fns/esm";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },

  actions: {
      marginTop:10,
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
  btn:{
    textTransform:"capitalize",
  },
  formTitle:{
    flexGrow:1,
},
paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    height:300,
    elevation:0
  },appBar: {
    position: 'relative',
  },title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },textField: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
  }
}));



function AuditTrails() {
    const classes = useStyles1();

    const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {

    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;


  const [auditTrails,setAuditTrails]=useState([]);

  const [entity,setEntity]=useState("SCHEDULE");

    const [timeFrom,setTimeFrom]=useState(new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}));
    const [dateFrom,setDateFrom]=useState(format(new Date(), ["yyyy-MM-dd"]));

    const [timeTo,setTimeTo]=useState(new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}));
    const [dateTo,setDateTo]=useState(format(new Date(), ["yyyy-MM-dd"]));




    const [action,setAction]=useState("WRITEN");
    const changeAction=(v)=>{
        setAction(v);
    }


    const [operatorData, setOperatorData] = useState({});

    useEffect(()=>{

      var data = {};
      const data1 = localStorage.getItem("nx_op");
      if (data1 != null) {
        data = JSON.parse(data1);
      }
  
      setOperatorData(data);
     
      
    },[]);


    const [loading,setLoading]=useState(false);
    const [message,setMessage]=useState("No audit trails available");



    const getTrails=()=>{
      setAuditTrails([]);
      setLoading(true);
      setMessage("Loading...");
      handleClose();
      const schedulesInstance = axios.create(new TransportService().setHeaders(operatorData.token));
      schedulesInstance.put(new ReportingService().GET_AUDIT_TRAILS,{
        "action": action,
        "entity": entity,
        "from": dateFrom+" "+timeFrom+":00",
        "to": dateTo+" "+timeTo+":00"
      })
      .then(res=>{

        setLoading(false);
        console.log("trails",res.data);
        var objs=res.data.data;

        if(objs.length==0){
          setMessage("No audit trails available");
        }else{
          setAuditTrails(objs);
        }
        
      })
      .catch(err=>{
        setLoading(false);
        setMessage("Something went wrong!");
      }); 


    }


    const columnsTrails = [
      {
        name: "recordRefNumber",
        label:"Ref Number",
        options: {
         filter: true,
         sort: true,
        }
    },
      {
        name: "entity",
        label:"Entity",
        options: {
         filter: true,
         sort: true,
        }
    },
      {
        name: "action",
        label:"Action",
        options: {
         filter: true,
         sort: true,
        }
    },
    {
     name: "lowData",
     label:"Low Data",
     options: {
      filter: true,
      sort: true,
     }
    },
     {
      name: "performedBy",
      label:"Performed By",
      options: {
       filter: true,
       sort: true,
      }
     },
     {
      name: "performedOn",
      label:"Performed On",
      options: {
       filter: true,
       sort: true,
      }
     },
    
   ];
  
  
  
   const optionsTrails= {
    textLabels: {
      body: {
        noMatch: message
      },
    },
     filterType: 'checkbox',
     download:true,
     responsive:"standard",
     selectableRows:false,
     rowsPerPage: 10,
     elevation:0
   };
  

    

    return(

        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div className={classes.root}>
        <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><GraphicEq fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>Audit Trails</b></Typography>

 </Box>



<Box className={classes.actions}>
<Chip mr={2} label="Written" clickable variant= {action=="WRITEN"?"default":"outlined"}  color={action=="WRITEN"?"primary":"secondary"}  onClick={()=>{
  changeAction("WRITEN");
}} />
<Chip p={1} label="Read" clickable variant= {action=="READ"?"default":"outlined"} color={action=="READ"?"primary":"secondary"} 
 onClick={()=>{
    changeAction("READ");
  }} />
<Chip p={1} label="Modified" clickable  variant= {action=="MODIFIED"?"default":"outlined"} color={action=="MODIFIED"?"primary":"secondary"}    onClick={()=>{
  changeAction("MODIFIED");
}}/>
<Chip p={1} label="Listed" clickable  variant= {action=="LISTED"?"default":"outlined"} color={action=="LISTED"?"primary":"secondary"}  onClick={()=>{
  changeAction("LISTED");
}} />
<Chip p={1} label="Status Changed" clickable variant= {action=="STATUS_CHANGED"?"default":"outlined"} color={action=="STATUS_CHANGED"?"primary":"secondary"} onClick={()=>{
  changeAction("STATUS_CHANGED");
}}/>
</Box>



<IconButton color="primary" aria-label="upload picture" component="span" onClick={handleClick}>
          <FilterList />
</IconButton>

<Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
       <Box p={2}>

           <FormControl variant="outlined" fullWidth size={"small"} >
        <InputLabel id="entity">Entity</InputLabel>
        <Select
          labelId="entity"
          id="entity"
          value={entity}
          onChange={(v)=>{
            // console.log(v.target.value)
            setEntity(v.target.value);
          }}
          label="Entity"
        >
          {/* <MenuItem value="">
            <em>None</em>
          </MenuItem> */}
          <MenuItem value={"SCHEDULE"}>Schedule</MenuItem>
          <MenuItem value={"TICKET"}>Ticket</MenuItem>
          <MenuItem value={"USER"}>User</MenuItem>
          <MenuItem value={"ROUTING"}>Routing</MenuItem>
        </Select>
      </FormControl>



<Box display="flex">
<Grid container spacing={0}>
        <Grid item xs={8} md={8} sm={12}>
        <DatePicker
                fullWidth
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                autoOk
                size="small"
                label="From"
                value={dateFrom}
                inputVariant="outlined"
                onChange={(v)=>{
                  console.log(Format(v, ["yyyy-MM-dd",]));
                  setDateFrom(Format(v, ["yyyy-MM-dd",]));
                }}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
        </Grid>

        <Grid item xs={4} md={4} sm={12}>
          
<TextField fullWidth
        id="timefrom"
        label="From time"
        variant="outlined"
        size="small"
        type="time"
        defaultValue={timeFrom}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          step: 300,
        }}
        onChange={(v)=>{
          console.log(v.target.value);
          setTimeFrom(v.target.value);
        }}
      />

        </Grid>

  </Grid>





</Box>

       

<Box display="flex">
<Grid container spacing={0}>
        <Grid item xs={8} md={8} sm={12}>
        <DatePicker
                fullWidth
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                autoOk
                size="small"
                label="To"
                value={dateTo}
                inputVariant="outlined"
                onChange={(v)=>{
                  console.log(Format(v, ["yyyy-MM-dd",]));
                  setDateTo(Format(v, ["yyyy-MM-dd",]));
                }}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
        </Grid>

<Grid item xs={4} md={4} sm={12}>
          
<TextField fullWidth
        id="timefrom"
        label="To time"
        variant="outlined"
        size="small"
        type="time"
        defaultValue={timeTo}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          step: 300,
        }}
        onChange={(v)=>{
          console.log(v.target.value);
          setTimeTo(v.target.value);
        }}
      />

        </Grid>

  </Grid>





</Box>



<Button className={classes.btn} variant="contained" disableElevation disabled={loading} color="primary" size="small"
onClick={()=>{
  getTrails();
}}
>
{loading==true?<CircularProgress size={25}/>:"Get Trails"}
</Button>

       </Box>
      </Popover>



</Box>



<Box mt={0}>
{loading&&<LinearProgress />}

<MUIDataTable
  data={auditTrails}
  columns={columnsTrails}
  options={optionsTrails}
/>

</Box>



            </div>

         </MuiPickersUtilsProvider>

    );

}


export default withLocalize(AuditTrails);